import React from 'react'
import PageError from '../Components/404Error/PageError'

const PageNotFound = () => {
  return (
    <div>
        <PageError />
    </div>
  )
}

export default PageNotFound